import { Box, Typography } from '@mui/material';

import { formatBaseMonthLabel } from '../dateUtils';

interface CompetenciaLabelProps {
  baseMonth?: string;
}

export function CompetenciaLabel({ baseMonth }: CompetenciaLabelProps) {
  if (!baseMonth) return null;
  return (
    <Typography variant="caption" color="text.secondary">
      Competência:{' '}
      <Box component="span" fontWeight={700} color="text.primary">
        {formatBaseMonthLabel(baseMonth)}
      </Box>
    </Typography>
  );
}
